// SYS-05 — Source de vérité unique pour les limites et durées des plans
// Importé par : createEvent.js, stripeWebhook.js, createPaidEventCheckout.js, composants frontend

export const PLAN_LIMITS = {
  free:     { max_participants: 15,  max_photos_per_participant: 8  },
  standard: { max_participants: 50,  max_photos_per_participant: 10 },
  plus:     { max_participants: 100, max_photos_per_participant: 15 },
  premium:  { max_participants: 250, max_photos_per_participant: 20 },
};

export const AI_MODERATION_PLANS = new Set(["plus", "premium"]);

// Durée de conservation des photos après la date de début de l'événement (en jours)
// Doit correspondre à functions/expireEvents.js
export const PLAN_DURATION_DAYS = {
  free:     7,
  standard: 30,
  plus:     30,
  premium:  30,
};

export function getRetentionDays(plan = "free") {
  return PLAN_DURATION_DAYS[plan] || PLAN_DURATION_DAYS.free;
}

/**
 * Calcule la date d'expiration des photos d'un événement.
 * @param {string} eventDate - Date de début de l'événement (ISO string)
 * @param {string} plan - Plan de l'événement
 * @returns {Date}
 */
export function getExpirationDate(eventDate, plan) {
  const base = new Date(eventDate);
  const days = getRetentionDays(plan);
  return new Date(base.getTime() + days * 86400000);
}

export function getPhotoExpirationDate(event) {
  const baseDate = event?.date || event?.end_date || event?.created_at || event?.created_date;
  if (!baseDate) return null;

  const expiresAt = getExpirationDate(baseDate, event?.plan || "free");
  return Number.isNaN(expiresAt.getTime()) ? null : expiresAt;
}

/**
 * Calcule le nombre de jours restants avant expiration.
 * @param {string} eventDate
 * @param {string} plan
 * @returns {number} jours restants (peut être négatif si déjà expiré)
 */
export function getDaysRemaining(eventDate, plan) {
  const expiry = getExpirationDate(eventDate, plan);
  return Math.ceil((expiry - Date.now()) / 86400000);
}

export function getMaxPhotosPerParticipant(event) {
  const planLimit = PLAN_LIMITS[event?.plan]?.max_photos_per_participant || PLAN_LIMITS.free.max_photos_per_participant;
  const explicitLimit = Number(event?.max_photos_per_participant || 0);

  if (event?.plan === "free") {
    return Math.max(explicitLimit, planLimit);
  }

  return explicitLimit || planLimit;
}

export function getDeleteLimitPerParticipant(plan = "free") {
  const maxPhotos = PLAN_LIMITS[plan]?.max_photos_per_participant || PLAN_LIMITS.free.max_photos_per_participant;
  return Math.floor(maxPhotos * 0.25);
}

export function getAiModerationQuota(plan = "free") {
  if (!AI_MODERATION_PLANS.has(plan)) return 0;
  const limits = PLAN_LIMITS[plan] || PLAN_LIMITS.free;
  return limits.max_participants * limits.max_photos_per_participant;
}

export function hasAiModerationPlan(plan = "free") {
  return AI_MODERATION_PLANS.has(plan);
}
